import React from 'react'
import './Excepcion.css';
import { Link } from 'react-router-dom';

function Excepcion() {
  localStorage.clear();
  return (
    <div className="main">
        <div className="box-exception">
            <p>No se encontró el sitio solicitado, presione el boton redireccionar para iniciar sesion.</p>            
           <center><Link className="button-small" to={ "/login" } >Redireccionar</Link></center>    
         </div>  
        
    </div> 
  )}

export default Excepcion